import _ from 'lodash';
import { createSelector, createStructuredSelector } from 'reselect';

export const getApp = (state) => state.app;

export const idSelector = createSelector(getApp, (app) => _.get(app, 'id'));

export const autoplaySelector = createSelector(getApp, (app) => _.get(app, 'autoplay'));

export const getParamAutoplaySelector = createSelector(getApp, (app) =>
  _.get(app, 'getParamAutoplay')
);

export const dataReadySelector = createSelector(getApp, (app) => _.get(app, 'dataReady'));

export const pathnameSelector = createSelector(getApp, (app) => _.get(app, 'pathname'));

export const loginValueSelector = createSelector(getApp, (app) => _.get(app, 'loginValue'));

export const userRequestedOnStartupSelector = createSelector(
  getApp,
  (app) => app.userRequestedOnStartup
);

export default createStructuredSelector({
  appSelector: getApp,
  idSelector,
  autoplaySelector,
  getParamAutoplaySelector,
  dataReadySelector,
  pathnameSelector,
  loginValueSelector,
});
